import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { SprinklerSystemDesign } from '@authority-labs/api-interfaces';
import { MeasureType } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-sprinkler-system-design-inspection',
  templateUrl: './sprinkler-system-design-inspection.component.html',
  styleUrls: ['./sprinkler-system-design-inspection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SprinklerSystemDesignInspectionComponent {
  @Input() data: SprinklerSystemDesign;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  cityWaterSupplyCharacteristics: MeasureType[] = [
    MeasureType.StaticPressure,
    MeasureType.ResidualPressure,
    MeasureType.FlowRate
  ];
  plumberRoomWaterSupplyCharacteristics: MeasureType[] = [
    MeasureType.StaticPressure,
    MeasureType.NominalPressure,
    MeasureType.FlowRate,
    MeasureType.PoolingVolume
  ];
  maxWaterCharacteristics: MeasureType[] = [MeasureType.WaterFlowPressure];
  poolingVolumeCharacteristics: MeasureType[] = [MeasureType.PoolingVolume];

  onDataChange(): void {
    this.dataChange.emit();
  }
}
